import {TranslateService} from "@ngx-translate/core";
import {Injectable} from "@angular/core";

@Injectable()
export class AnalyticsTitleResolver {
	constructor(private translate: TranslateService) {
	}

	public resolve() {
		return this.translate.instant('hcm.analytics.project_name');
	}
}

@Injectable()
export class MyAnalyticsTitleResolver {
	constructor(private translate: TranslateService) {
	}

	public resolve() {
		return this.translate.instant('hcm.analytics.router_my_analytics');
	}
}

@Injectable()
export class TeamAnalyticsTitleResolver {
	constructor(private translate: TranslateService) {
	}

	public resolve() {
		return this.translate.instant('hcm.analytics.analytics_team_breadcrumb');
	}
}

@Injectable()
export class LedAnalyticsTitleResolver {
	constructor(private translate: TranslateService) {
	}

	public resolve() {
		return this.translate.instant('hcm.analytics.analytics_led_breadcrumb');
	}
}

@Injectable()
export class RemunerationAnalyticsTitleResolver {
	constructor(private translate: TranslateService) {
	}

	public resolve() {
		return this.translate.instant('hcm.analytics.analytics_remuneration_breadcrumb');
	}
}

@Injectable()
export class RecruitmentAnalyticsTitleResolver {
	constructor(private translate: TranslateService) {
	}

	public resolve() {
		return this.translate.instant('hcm.analytics.analytics_recruitment_breadcrumb');
	}
}

@Injectable()
export class PerformanceAnalyticsTitleResolver {
	constructor(private translate: TranslateService) {
	}

	public resolve() {
		return this.translate.instant('hcm.analytics.analytics_performance_breadcrumb');
	}
}

@Injectable()
export class PayrollAnalyticsTitleResolver {
	constructor(private translate: TranslateService) {
	}

	public resolve() {
		return this.translate.instant('hcm.analytics.analytics_payroll_breadcrumb');
	}
}

@Injectable()
export class MoodsAnalyticsTitleResolver {
	constructor(private translate: TranslateService) {
	}

	public resolve() {
		return this.translate.instant('hcm.analytics.analytics_moods_breadcrumb');
	}
}

@Injectable()
export class PointAnalyticsTitleResolver {
	constructor(private translate: TranslateService) {
	}

	public resolve() {
		return this.translate.instant('hcm.analytics.analytics_appointment_breadcrumb');
	}
}
